import * as FCU from "@fluentui/react-components/unstable";
import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useState } from "react";
/**
 * @typedef {Object} useDrawerRet
 * @property openDrawer
 * @property closeDrawer
 * @property drawer
 */

/**
 * @param {import("@fluentui/react-components/unstable").DrawerOverlayProps} props
 * @returns {useDrawerRet}
 */
export const useDrawer = (props) => {
    let [open, setOpen] = useState(false);

    let [header, setHeader] = useState(null);
    let [body, setBody] = useState(null);

    let openDrawer = ({ header, body }) => {
        setHeader(header);
        setBody(body);
        setOpen(true);
    };
    let closeDrawer = () => {
        setHeader(null);
        setBody(null);
        setOpen(false);
    };

    if (!body) {
        return {
            openDrawer,
            closeDrawer,
            drawer: null,
        };
    }

    let drawer = (
        <FCU.DrawerOverlay
            position="right"
            onOpenChange={(_, { open }) => setOpen(open)}
            open={open}
           {...props}
        >
            <FCU.DrawerHeader>
                <FCU.DrawerHeaderTitle
                    action={
                        <FC.Button
                            appearance="subtle"
                            aria-label="Close"
                            icon={<IC.Dismiss24Regular />}
                            onClick={() => setOpen(false)}
                        />
                    }
                >
                    {header}
                </FCU.DrawerHeaderTitle>
            </FCU.DrawerHeader>
            <FCU.DrawerBody>{body}</FCU.DrawerBody>
        </FCU.DrawerOverlay>
    );

    return {
        openDrawer,
        closeDrawer,
        drawer,
    };
};
